export default "__VITE_ASSET__DdSAevGN__"